import { render, staticRenderFns } from "./posTransactions.vue?vue&type=template&id=1cd7901a&"
import script from "./posTransactions.vue?vue&type=script&lang=js&"
export * from "./posTransactions.vue?vue&type=script&lang=js&"
import style0 from "./posTransactions.vue?vue&type=style&index=0&id=1cd7901a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports